<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template> 
  <div class="mapbox-map elevation-3" id="map">   
    <div id="menulayer" @click="toggleLayerPicker()" title="Toggle Layers">
      <img src="../../public/assets/layers.png" style="width: 20px; margin-top: 5px; cursor: pointer;" />
    </div>       
    <nav v-show="showLayerPicker" id="menu">
      <span>Turn layers on/off</span>
    </nav>
    <select v-show="showLayerPicker" id="heatSelect" @change="getSelectedHeatValue">
      <option class="heatSelectOption" selected value="Confirmed">Heatmap of Confirmed</option>
      <option class="heatSelectOption" value="Recovered">Heatmap of Recovered</option>
      <option class="heatSelectOption" value="Active">Heatmap of Active</option>
      <option class="heatSelectOption" value="Deaths">Heatmap of Deaths</option>
    </select>
    <!-- <div id="state-legend" class="legend">
    <h4 class="mb-0 pb-0">Population</h4>
    <h4 class="mt-0 pt-0">(Per Province)</h4>    
      <div><span style="background-color: #7105a2"></span>> 20 %</div>    
      <div><span style="background-color: #7a0177"></span>15-20 %</div>
      <div><span style="background-color: #ae017e"></span>10-15 %</div>
      <div><span style="background-color: #dd3497"></span>5-10 %</div>
      <div><span style="background-color: #f768a1"></span>0-5 %</div>
    </div> -->
  </div>       

</template>

<script>

  import mapboxgl from 'mapbox-gl'
  import 'mapbox-gl/dist/mapbox-gl.css'
  import Papa from 'papaparse'
  
  export default {
    name: 'Map',
    data: () => ({

      map: null,
      dataSA:null,
      dataGlobal:null,
      dataSAProvinceDetailGeo:{},
      dataSAProvinceDetail:[],      
      globalDataFeaturesJH: [],
      sourcesa: {},
      layersa: null,
      sourcesatravel: {},
      layersatravel: null,
      sourceglobal: {},
      sourcesaprovdetail: {},
      layerglobal: null,
      sourceSAProvince: {},
      layerSAProvince: null,
      mapLoaded: false,
      layersList:[],
      globalHeatSelector: "Confirmed",
      countryData: null,
      provinceFilter: [],
      firstLoad: true,
      provinceDisplay: "",
      mapDraw: false,
      showLayerPicker: false

    }),
    mounted () { // this vue component 
      this.loadMap()
    },
    watch: {
      provinceDisplay: function (val) {           
        this.filterProv(val)
      }
    },
    methods: {
      loadCases(data, provinceDisplay) {       
        var thisRef = this

        //find the latest summary entries
        //first get the distinct dates
        var dates = [];
        dates = Array.from(new Set(data.map(summ => summ.date))).map(date => {
          return date;
        });

        //find the date of the last entry
        var lastCaseDate = dates[dates.length - 1]
        var matchLast = []

        //check if only one prov selected
        if(provinceDisplay && provinceDisplay !== "") {
          var matchLast = data.filter(c => c.date === lastCaseDate && c.region === provinceDisplay)
        }
        else {
          //filter all the last provs
          var matchLast = data.filter(c => c.date === lastCaseDate)
        }
        
        //console.log("isMapLoaded", this.mapLoaded)       
        if (thisRef.firstLoad == true){

            // //make a copy of the data and store only active cases
            // var copy = JSON.parse(JSON.stringify(data))
            // var activeonly = copy.filter(c => c.status === "Active")

            thisRef.dataSA = matchLast
            thisRef.firstLoad = false
        }
        else {
            // //make a copy of the data and store only active cases
            // var copy = JSON.parse(JSON.stringify(data))
            // var activeonly = copy.filter(c => c.status === "Active")

            thisRef.dataSA = matchLast
            thisRef.processSAData()
        }

        // used to filter breakdown stats 
        this.provinceDisplay = provinceDisplay         
      },     
      loadMap() {

        let thisRef = this
        mapboxgl.accessToken = 'pk.eyJ1Ijoic2hhemlhdiIsImEiOiJjamt1eDl1MG0wam9wM2txbmc5em52dzVzIn0.5GURhst0HPYdFs8BlVHH1Q'
        var map = this.map

        map = new mapboxgl.Map({
          container: 'map', // container id
          //style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
          style: 'https://api.maptiler.com/maps/1314eca6-6818-4d57-af25-e8e5eab2e73b/style.json?key=m9rARlck6j9xxXkBz21x',
          center: [24, -28], // starting position [lng, lat]
          zoom: 4.5 // starting zoom
        })
        this.map = map

        map.addControl(new mapboxgl.NavigationControl())
        map.addControl(new mapboxgl.FullscreenControl())
        map.addControl(
        new mapboxgl.GeolocateControl({
            positionOptions: {
              enableHighAccuracy: true
              },
              trackUserLocation: true
            })
        );  

        map.on('load', function () {  
            
            //console.log("MAP", thisRef.dataSA, thisRef.dataGlobal)             
            thisRef.mapLoaded = true
            thisRef.addSources()
            thisRef.addLayers()              
            thisRef.getSAProvinceData()
            thisRef.getCountryData()
            thisRef.getGlobalData()             
            thisRef.processSAData()
            thisRef.getSALocalGeoData()
        });

      },
      resize: function() {
        var thisRef = this
        setTimeout(function(){
          thisRef.map.resize()
        }, 500)
      },
      addSources() {
        let thisRef = this
        let map = this.map

        thisRef.sourcesa =  {
          "type": "geojson",
          "data": {
              "type": "FeatureCollection",
              "features": []
          },
          //cluster: true,
          //clusterMaxZoom: 14, // Max zoom to cluster points on
          //clusterRadius: 10 // Radius of each cluster when clustering points (defaults to 50)
        }
        map.addSource('covid-sa-cases', thisRef.sourcesa)

        thisRef.sourcesaprovdetail =  {
          "type": "geojson",
          "data": {
              "type": "FeatureCollection",
              "features": []
          }
        }
        map.addSource('covid-sa-cases-prov-detail', thisRef.sourcesaprovdetail)

        thisRef.sourceglobal=  {
          "type": "geojson",
          "data": {
              "type": "FeatureCollection",
              "features": []
          }
        }
        map.addSource('covid-global-heat', thisRef.sourceglobal)

        thisRef.sourcesatravel =  {
          "type": "geojson",
          lineMetrics: true,
          "data": {
              "type": "FeatureCollection",             
              "features": []
          }
        }
        map.addSource('covid-sa-travel', thisRef.sourcesatravel)

        thisRef.sourceSAProvince=  {
          "type": "geojson",
          "data": {
              "type": "FeatureCollection",
              "features": []
          }
        }
        map.addSource('sa-province', thisRef.sourceSAProvince)

      },
      clearSources() {
        let thisRef = this
        let map = this.mapref

        if (this.sourcesa)
          this.sourcesa.data.features = []
          if (map.getSource("covid-sa-cases"))
              map.getSource('covid-sa-cases').setData(thisRef.sourcesa.data);

        if (this.sourcesaprovdetail)
          this.sourcesaprovdetail.data.features = []
          if (map.getSource("covid-sa-cases-prov-detail"))
              map.getSource('covid-sa-cases-prov-detail').setData(thisRef.sourcesaprovdetail.data);

        if (this.sourceglobal)
          this.sourceglobal.data.features = []
          if (map.getSource("covid-global-heat"))
              map.getSource('covid-global-heat').setData(thisRef.sourceglobal.data);

         if (this.sourcesatravel)
          this.sourcesatravel.data.features = []
          if (map.getSource("covid-sa-travel"))
              map.getSource('covid-sa-travel').setData(thisRef.sourcesatravel.data);

         if (this.sourceSAProvince)
          this.sourceSAProvince.data.features = []
          if (map.getSource("sa-province"))
              map.getSource('sa-province').setData(thisRef.sourceSAProvince.data);

       },
      updateSources() {

      },
      addLayers() {

        this.createSAClusterLayer()
        //this.createSATravelLayer()     
        this.createGlobalHeatLayer()
        //this.createSAProvinceLayer()
        //this.createSAClusterProvDetailLayer()
        //
        this.setupToggleLayers()

      },
      setupToggleLayers() {

        var toggleableLayerIds = this.layersList
        var map = this.map

        for (var i = 0; i < toggleableLayerIds.length; i++) {
          var id = toggleableLayerIds[i];
          
          var link = document.createElement('a');
          link.href = '#';
          link.className = 'active';
          link.textContent = id;

          // if(id === 'Countries Travelled') {
          //   link.className = '';
          // }
          
          link.onclick = function(e) {
          var clickedLayer = this.textContent;
          e.preventDefault();
          e.stopPropagation();
          
          var visibility = map.getLayoutProperty(clickedLayer, 'visibility');
          
          if (visibility === 'visible') {
            map.setLayoutProperty(clickedLayer, 'visibility', 'none');
            this.className = '';

            //toggle layer picker
            if(clickedLayer === "Global Heatmap") {
              document.getElementById('heatSelect').style.display = "none";
            }

          } else {
            this.className = 'active';
            map.setLayoutProperty(clickedLayer, 'visibility', 'visible');

            if(clickedLayer === "Global Heatmap") {
              document.getElementById('heatSelect').style.display = "block";
            }
          }
          };
          
          var layers = document.getElementById('menu');
          layers.appendChild(link);
        }

      },
      createSAProvinceLayer() {

        let map = this.map

        map.addLayer({
          'id': 'sa-province-poly',
          'type': 'fill',
          'source': 'sa-province',
          'layout': {},         
          'paint': {
            'fill-color': [
            'interpolate',
            ['linear'],
            ['get', 'populationPerc'],
              0,
              '#f768a1',
              5,
              '#dd3497',
              10,
              '#ae017e',
              15,
              '#7a0177',                   
              25,
              '#7105a2'
            ],
            'fill-opacity': 0.45
          }
        },"Countries Travelled");

        // map.on('click', 'sa-province-poly', function(e) {
          
        //   var populationPerc = e.features[0].properties.populationPerc;
        //   var populationEsti = e.features[0].properties.populationEstimate;         
          
        //   new mapboxgl.Popup({
        //     //closeButton: false,
        //     // closeOnClick: false,
        //     className: 'popup-class'
        //   })
        //   .setLngLat(e.lngLat)
        //   .setHTML("Population % : " + populationPerc + " %" + "<br>" + 
        //           "Population # " + populationEsti + "<br>"
        //           )
        //   .addTo(map)

        // });

        // map.on('mouseenter', 'sa-province-poly', function() {
        //   map.getCanvas().style.cursor = 'pointer';
        // });
        // map.on('mouseleave', 'sa-province-poly', function() {
        //   map.getCanvas().style.cursor = '';
        // });

        // map.addLayer({
        //   id: "sa-province-label",
        //   type: 'symbol',
        //   source: "sa-province",
        //   layout: {
        //     'text-field': ["get", "populationPerc"],
        //     'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
        //     'text-size': 12
        //   },
        //   paint: {
        //     'text-color': "#fff"
        //   }
        // });

      },
      createSATravelLayer() {

        let map = this.map
        let thisRef = this

        thisRef.layersList.push("Countries Travelled")

        map.addLayer({
          'id': 'Countries Travelled',
          'source': 'covid-sa-travel',
          'type': 'line',       
          'layout': {
              'visibility': 'visible',
            },
          "paint": {
            "line-color": "#007cbf",
            "line-opacity": 0.10,
            "line-width": 3,
            'line-gradient': [
                'interpolate',
                ['linear'],
                ['line-progress'],
                0,"#D7808A", 
                0.5,"#C2676F",
                0.6,"#B85A62",
                0.7,"#A34147",
                0.8,"#99343A",
                0.9,"#8F282D",
                1,"#c8b91f"                
            ]
          },
        },"covid-sa-cases-cluster");     
        
        // Create a popup, but don't add it to the map yet.
        var popup = new mapboxgl.Popup({
          closeButton: false,
          closeOnClick: true,
          className: 'popup-class'
        });
        
        map.on('click', 'Countries Travelled', function(e) {
          // Change the cursor style as a UI indicator.
          map.getCanvas().style.cursor = 'pointer';
          
          var description = e.features[0].properties;

          var caseId = e.features[0].properties.case_id;
          var date = e.features[0].properties.date;
          var country = e.features[0].properties.country;
          var province = e.features[0].properties.province;
          var age = e.features[0].properties.age;
          var gender = e.features[0].properties.gender;
          var transmission_type = e.features[0].properties.transmission_type;
          var travel_countries = e.features[0].properties.travel_countries;
          var status = e.features[0].properties.status;
          var statusChanageDate = e.features[0].properties.statusChanageDate;            
          
          var description = "Case: " + caseId + "<br>" + 
                  "Date: " + date + "<br>" +
                  "Country: " + country + "<br>" +
                  "Province: " + province + "<br>" +
                  "Age: " + age + "<br>" +
                  "Gender: " + gender + "<br>" +
                  "Transmission_type: " + transmission_type + "<br>" +
                  "Status: " + status + "<br>"          
          
          // Populate the popup and set its coordinates
          // based on the feature found.
          popup
            .setLngLat(e.lngLat)
            .setHTML(description)
            .addTo(map);
          });
          
        // map.on('mouseleave', 'Countries Travelled', function() {
        //   map.getCanvas().style.cursor = '';
        //   popup.remove();
        // });

        map.on('mouseenter', 'Countries Travelled', function() {
          map.getCanvas().style.cursor = 'pointer';
        });
        map.on('mouseleave', 'Countries Travelled', function() {
          map.getCanvas().style.cursor = '';
        });

      },
      createSAClusterProvDetailLayer() {

        let map = this.map

        map.addLayer({
          'id': 'covid-sa-cases-cluster-prov-detail-text',
          'type': 'symbol',
          "source": "covid-sa-cases-prov-detail",
            layout: {
            'text-field': ["concat", ["get", "displayRegion"], " : ", ["get", "confirmed"]],
            'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
            'text-size': 11
          },
          paint: {
            'text-color': "#fff",
            'text-opacity': {
               'stops': [[1, 0], [4, 0.15], [7, 0.75]]
            }

          },
          filter: ['>', ['get', 'confirmed'], 0]
        });
   
          
        map.addLayer({
          "id": "covid-sa-cases-cluster-prov-detail",
          'type': 'fill-extrusion',
          "source": "covid-sa-cases-prov-detail",
          'layout': {
              'visibility': 'visible',
          },   
          'paint': {
            // 'fill-color': [
            //   'interpolate',
            //   ['linear'],
            //   ['get', 'confirmed'],
            //     1,
            //     '#4dbaff',
            //     10,
            //     '#1aa7ff',
            //     100,
            //     '#008de6',
            //     1000,
            //     '#007ecc',                   
            //     10000,
            //     '#006eb3'
            // ],
            // 'fill-opacity': {
            //    'stops': [[1, 0], [4, 0.15], [7, 0.75]]
            // },
            // Get the fill-extrusion-color from the source 'color' property.
            'fill-extrusion-color': [
              'interpolate',
              ['linear'],
              ['get', 'confirmed'],
                1,
                '#0090E5',
                100,
                '#3F60A3',
                250,
                '#54508D',
                500,
                '#6A4078',                   
                1000,
                '#7F3062',
                2500,
                '#94204C',
                5000,
                '#961E49',
                10000,
                '#A91036'
            ],            
            // Get fill-extrusion-height from the source 'height' property.
            'fill-extrusion-height': [
               'interpolate',
              ['linear'],
              ['get', 'confirmed'],
              1,100,250,500,1000,2500,5000,10000       
              //10000,100000
            ],                          
            // Make extrusions slightly opaque for see through indoor walls.
            'fill-extrusion-opacity': {
              'stops': [[1, 0], [4, 0.15], [7, 0.85]]
            }
          },
          filter: ['>', ['get', 'confirmed'], 0]
        })
        

        map.moveLayer('covid-sa-cases-cluster-prov-detail', 'covid-sa-cases-cluster-prov-detail-text'); 
        map.moveLayer('covid-sa-cases-cluster-prov-detail', 'covid-sa-cases-cluster');
        map.moveLayer('covid-sa-cases-cluster-prov-detail-text', 'covid-sa-cases-cluster');


        map.addLayer({
          'id': 'covid-sa-cases-cluster-prov-detail-line',
          'type': 'line',
          "source": "covid-sa-cases-prov-detail",
          'layout': {},         
          'paint': {
            'line-color': '#fff',
            'line-width': 1,
            'line-opacity': {
               'stops': [[1, 0], [4, 0.10], [7, 0.15]]
            }
          },
          filter: ['>', ['get', 'confirmed'], 0]
        });

              
         // Create a popup, but don't add it to the map yet.
        var popup = new mapboxgl.Popup({
          closeButton: false,
          //closeOnClick: true,
          className: 'popup-class'
        });
        
        map.on('click', 'covid-sa-cases-cluster-prov-detail', function(e) {
          // Change the cursor style as a UI indicator.
          map.getCanvas().style.cursor = 'pointer';
          popup.remove();
          
          //var description = e.features[0].properties;

          var confirmed = e.features[0].properties.confirmed;
          var recovered = e.features[0].properties.recovered;
          var deaths = e.features[0].properties.deaths;
          var active = e.features[0].properties.active;
          var districtName = e.features[0].properties.DISTRICT_N;
          var municName = e.features[0].properties.MUNICNAME;   
          var level = e.features[0].properties.level;
          var provStr = e.features[0].properties.provincestring
          var hasRecovered = e.features[0].properties.hasRecovered
          var hasDeaths = e.features[0].properties.hasDeaths
          var cities = e.features[0].properties.city
         
          if (municName === "null") {
            municName = 'Unavailable'
          }
          
          var description = "<b>Province: " + provStr + "</b><br>" +
                  "<b>Region: " + districtName + "</b><br>" +
                  "<b>Sub-Region: " + municName + "</b><br>"

          if(cities !== "") {
            description += "Areas: " + cities + "<br>"
          }
                  
           description += "<br>Confirmed: " + confirmed + "<br>"

          if(hasRecovered) {
            description += "Recovered: " + recovered + "<br>"
          }
          else {
            description += "Recovered: " + "-" + "<br>"
          }

          if(hasDeaths) {
            description += "Deaths: " + deaths + "<br>"
          }
          else {
            description += "Deaths: " + "-" + "<br>"
          }
                  
          if(hasRecovered && hasDeaths) {
            description += "Active: " + active + "<br>"
          }
          else {
            description += "Active: " + "-" + "<br>"
          }  
          
          description += "Lockdown Restriction Level: " + level + "<br>"     
                                                 
          // Populate the popup and set its coordinates
          // based on the feature found.

          // new mapboxgl.Popup({
          // closeButton: false,
          // //closeOnClick: true,
          // className: 'popup-class'
          // })
          popup
          .setLngLat(e.lngLat)
          .setHTML(description)
          .addTo(map)

         
        })

         map.on('mouseenter', 'covid-sa-cases-cluster-prov-detail', function() {
            map.getCanvas().style.cursor = 'pointer';
          });

        map.on('mouseleave', 'covid-sa-cases-cluster-prov-detail', function() {
          map.getCanvas().style.cursor = '';
          popup.remove();
        });       

      },
      createSAClusterLayer() {
        
        let map = this.map
        let thisRef = this
        
        map.addLayer({
          id: "covid-sa-cases-cluster",
          type: "circle",
          source: "covid-sa-cases",
          'layout': {
              'visibility': 'visible',
          },
          paint: {           
              "circle-color": "#F86624",
              "circle-radius": [
                  "step",
                  ["get", "active"],
                  10,
                  1000,
                  20,
                  10000,
                  30,
                  50000,
                  40
              ],
              "circle-stroke-width": {
                'stops': [[1, 0], [20, 6]]
                },
                "circle-stroke-opacity": {
                'stops': [[1, 0.0], [20, 0.4]]
                },
                "circle-stroke-color": "#F86624"
          }
        })
        
        map.addLayer({
          id: "covid-sa-cases-cluster-count",
          type: 'symbol',
          source: "covid-sa-cases",
          filter: ['has', 'active'],
          layout: {
            'text-field': '{active}',
            'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
            'text-size': 16,
          },
          paint: {
            'text-color': "#fff"
          }
        });

        // // map.addLayer({
        //   id: 'covid-sa-cases-unclustered-point',
        //   type: 'circle',
        //   source: "covid-sa-cases",
        //   filter: ['!', ['has', 'confirmed']],
        //   paint: {
        //   'circle-color': '#e91e63 ',
        //   'circle-radius': 4,
        //   'circle-stroke-width': 1,
        //   'circle-stroke-color': '#e91e69 '
        //   }
        // });

        // inspect a cluster on click
        map.on('click', 'covid-sa-cases-cluster', function(e) {

          var coordinates = e.features[0].geometry.coordinates.slice();        
          
          var features = map.queryRenderedFeatures(e.point, {
             layers: ['covid-sa-cases-cluster']
          });
          
          var clusterId = features[0].properties.cluster_id;
          var point_count = features[0].properties.point_count,
          clusterSource = map.getSource('covid-sa-cases');

          // // Get all points under a cluster
          // var popUpData = null
          // clusterSource.getClusterLeaves(clusterId, point_count, 0, function(err, aFeatures){
          //   //console.log('getClusterLeaves', err, aFeatures);
          //   // 
          //   popUpData = thisRef.processClusterClick(aFeatures)

          //   if (aFeatures)
          //   if (aFeatures.length > 1) {
          //     showPopUp(popUpData)
          //   }
          // })

          showPopUp(e.features[0].properties)

          function showPopUp(data) {
            // Ensure that if the map is zoomed out such that
            // multiple copies of the feature are visible, the
            // popup appears over the copy being pointed to.
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }

            var active = (data.confirmed*1) - (data.recovered*1) - (data.deceased*1)
            var displayText = ""
            displayText = "<b>" + data.region + "</b>" + "<br>"
            displayText = displayText + "Confirmed : " + data.confirmed + "<br>"
            displayText = displayText + "Recovered : " + data.recovered + "<br>"
            displayText = displayText + "Deaths : " + data.deceased + "<br>"
            displayText = displayText + "Active : " + active + "<br>"
            displayText = displayText + "Lockdown Restriction Level : " + data.level + "<br>"
           

            new mapboxgl.Popup({
              closeButton: false,
              // closeOnClick: false,
              className: 'popup-class'
            })
            .setLngLat(coordinates)
            .setHTML(displayText                                          
                    )
            .addTo(map)
          }
         
        });

        map.on('click', 'covid-sa-cases-unclustered-point', function(e) {
 
          var coordinates = e.features[0].geometry.coordinates.slice();
          
          var caseId = e.features[0].properties.case_id;
          var date = e.features[0].properties.date;
          var country = e.features[0].properties.country;
          var province = e.features[0].properties.province;
          var age = e.features[0].properties.age;
          var gender = e.features[0].properties.gender;
          var transmission_type = e.features[0].properties.transmission_type;
          var travel_countries = e.features[0].properties.travel_countries;
          var status = e.features[0].properties.status;
          var statusChanageDate = e.features[0].properties.statusChanageDate;  
          
          // Ensure that if the map is zoomed out such that
          // multiple copies of the feature are visible, the
          // popup appears over the copy being pointed to.
          while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
          }
          
          new mapboxgl.Popup({
            closeButton: false,
            // closeOnClick: false,
            className: 'popup-class'
          })
          .setLngLat(coordinates)
          .setHTML("Case: " + caseId + "<br>" + 
                  "Date: " + date + "<br>" +
                  "Country: " + country + "<br>" +
                  "Province: " + province + "<br>" +
                  "Age: " + age + "<br>" +
                  "Gender: " + gender + "<br>" +
                  "Transmission_type: " + transmission_type + "<br>" +
                  "Status: " + status + "<br>"
                  )
          .addTo(map)

        });

        map.on('mouseenter', 'covid-sa-cases-cluster', function() {
          map.getCanvas().style.cursor = 'pointer';
        });
        map.on('mouseleave', 'covid-sa-cases-cluster', function() {
          map.getCanvas().style.cursor = '';
        });

      },
      createGlobalHeatLayer() {

        let map = this.map

        this.layersList.push("Global Heatmap")
        //
        map.addLayer(
          {
            'id': 'Global Heatmap',
            'type': 'heatmap',
            'source': 'covid-global-heat',
            'layout': {
              'visibility': 'visible',
            },
            'maxzoom': 9,
             paint: {
                // increase weight as diameter breast height increases
                'heatmap-weight': [
                    'interpolate',
                    ['linear'],
                    ['get', this.globalHeatSelector],
                    0,                    
                    0,
                    1,
                    1                   
                ],
                // increase intensity as zoom level increases
                'heatmap-intensity': [
                  'interpolate',
                  ['linear'],
                  ['zoom'],
                  0,
                  1,
                  9,
                  3
                ],
                // increase radius as zoom increases
                'heatmap-radius': {
                  stops: [
                      [5, 15],
                      [10, 25],
                      [15, 35]
                  ]
                },
                // decrease opacity to transition into the circle layer
                'heatmap-opacity': [
                  'interpolate',
                  ['linear'],
                  ['zoom'],
                  7,
                  1,
                  9,
                  0
                ]
             }        
          },          
        )
      },
      getCountryData() {

        let thisRef = this

        var d = new Date()
        var url = "data/geo/countries.csv"
        url += "?etag=" + d.toISOString()

        Papa.parse(url, {
          download: true,
          header: true,
          skipEmptyLines: true,
          complete: function(results) {
              //console.log('COUNTRY DATA', results.data)
              // .name .lat .lng
              var data = results.data
              thisRef.countryData = new Map() //results.data
              for (let key in data) { 
                let country = data[key]
                //thisRef.countryData[country.name] = [country.lng, country.lat]
                thisRef.countryData.set(country.name, [parseInt(country.lng), parseInt(country.lat)])
              }
              
          }
        })
      },
      getGlobalData() {

        var thisRef = this
        //
        this.getGlobalDataFeaureLayerJH()
        //
        // var url = "data/global/time_series_covid19_confirmed_global.csv"       
        // var confirmedFeaturesFlag = this.getGlobalDataJH(url, "Confirmed")
        //
        // var url = "data/global/time_series_covid19_deaths_global.csv"       
        // var confirmedFeaturesFlag = this.getGlobalDataJH(url, "Deaths")
        // //
        // var url = "data/global/time_series_covid19_recovered_global.csv"       
        // var confirmedFeaturesFlag = this.getGlobalDataJH(url, "Recovered")        
        //console.log(confirmedFeaturesFlag, thisRef.globalDataFeaturesJH)
        
      },
      getGlobalDataJH(url, type) {
        var thisRef = this
        var source = thisRef.sourceglobal
        var map = thisRef.map

        var d = new Date()
        url += "?etag=" + d.toISOString()

        Papa.parse(url, {
          download: true,
          header: true,
          skipEmptyLines: true,
          complete: function(results) {
               var data = results.data
              var globalDataFeaturesJH = thisRef.globalDataFeaturesJH
              for (let key in data) { 
                let info = data[key]
                let tempFeature = {}
                tempFeature["province_state"] = info["Province/State"]
                tempFeature["country_region"] = info["Country/Region"]
                tempFeature["lat"] = info["Lat"]
                tempFeature["long"] = info["Long"]
                //
                for (let infoKey in info) {
                    //                  
                    if (infoKey.match("Province/State") === null &&
                        infoKey.match("Country/Region") === null &&
                        infoKey.match("Lat") === null &&
                        infoKey.match("Long") === null) {

                        let infoDetail = info[infoKey]
                        let caseType = type
                        
                        let caseObject = {
                          province_state: tempFeature["province_state"],
                          country_region: tempFeature["country_region"],
                          lat:  tempFeature["lat"],
                          long:  tempFeature["long"],
                          date: infoKey,
                          [caseType]: infoDetail                      
                        }

                        let feature = thisRef.getFeature(caseObject)
                        source.data.features.push(feature)
                        //globalDataFeaturesJH.push(caseObject)
                    } 
                }
              }
              
              if (map.getSource("covid-global-heat"))
                map.getSource('covid-global-heat').setData(thisRef.sourceglobal.data);              
              
              return true
          }
        })        
      },
      getGlobalDataFeaureLayerJH() {
        var thisRef = this
        // data source: https://www.arcgis.com/home/item.html?id=c0b356e20b30490c8b8b4c7bb9554e7c&view=list#overview
        // terms of use: This public and shared service is available for your personal or noncommercial use. Data sources are WHO, US CDC, China NHC, ECDC, and DXY. This service is supported by Esri Living Atlas team and JHU Data Services. Please contact us for further questions.
        fetch('https://services1.arcgis.com/0MSEUqKaxRlEPj5g/arcgis/rest/services/ncov_cases/FeatureServer/1/query?f=json&where=1%3D1&returnGeometry=false&spatialRel=esriSpatialRelIntersects&outFields=*&orderByFields=OBJECTID%20ASC&resultOffset=0&cacheHint=true&quantizationParameters=%7B%22mode%22%3A%22edit%22%7D')
          .then(response => {
            return response.json()
          })
          .then(data => {
            // Work with JSON data here
            //console.log(data)
            thisRef.dataGlobal = data.features               
            thisRef.processGlobalData()         
          })
          .catch(err => {
            // Do something for an error here
        })
      },
      getProvinceCaseData(dataUrl, callback) {

        let thisRef = this
        let source = this.sourcesaprovdetail
        let dataSAProvArray = this.dataSAProvinceDetail
        let map = this.map
    
        var d = new Date()
        var url = dataUrl
        url += "?etag=" + d.toISOString()
        
        Papa.parse(url, {
          download: true,
          header: true,
          skipEmptyLines: true,
          complete: function(results) {
            //
            var data = results.data   
            for (var info of data) {
              dataSAProvArray.push(info)
            }
            callback()            
          }
        })

      },
      filterProv(prov) {

        var map = this.map
        var mapLoad = this.mapLoaded

        if (!mapLoad)
          return

        var filters = [
            "all",
            [">", ['get', 'confirmed'], 0],
            ['==', ['get', 'provincestring'], prov]
        ]

        if (prov == "") {
            filters = [
              "all",
              [">", ['get', 'confirmed'], 0]
          ]
        }
    
        //this.map.setFilter('covid-sa-cases-cluster-prov-detail', filters)           
        //this.map.setFilter('covid-sa-cases-cluster-prov-detail-text', filters)     
        
        var coordinates = []
        var src = map.getSource('covid-sa-cases-prov-detail')._data.features
        for (var i = 0; i < src.length; i++) {

          //check if prov selected
          if(prov !== "") {
            if(src[i].properties.PROVINCE.toLowerCase() === prov.toLowerCase()) {
              for (var j = 0; j < src[i].geometry.coordinates[0][0].length; j++) {
                coordinates.push(src[i].geometry.coordinates[0][0][j])
              }
            }

            this.map.setPitch(60)
          }
          else {
            for (var j = 0; j < src[i].geometry.coordinates[0][0].length; j++) {
              coordinates.push(src[i].geometry.coordinates[0][0][j])
            }

            this.map.setPitch(0)
          }          
        }
 
        // Pass the first coordinates in the LineString to `lngLatBounds` &
        // wrap each coordinate pair in `extend` to include them in the bounds
        // result. A variation of this technique could be applied to zooming
        // to the bounds of multiple Points or Polygon geomteries - it just
        // requires wrapping all the coordinates with the extend method.
        var bounds = coordinates.reduce(function(bounds, coord) {
          return bounds.extend(coord);
        }, new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));
        
        

        this.map.fitBounds(bounds, {
          //padding: 20
        });

        
            
      },
      processSALocalProvCases() {
        
        var thisRef = this
        var map = thisRef.map
        var source = this.sourcesaprovdetail
        let salocalGeo = thisRef.dataSAProvinceDetailGeo
        var data = this.dataSAProvinceDetail
        var provFilter = this.provinceDisplay

        source.data.features = []

        //console.log(salocalGeo, data)
        var idCount = 0

        for (var feat of salocalGeo) {
            
            //              
            var cases = 0   
            var recovered = 0
            var deaths = 0
            var active = 0
            var provincestring = ""
            var level = ""
            var hasRecovered = false
            var hasDeaths = false
            var displayRegion = ""
            var city = ""

            for (var info of data) {

              //
              if ((info.district_munic == feat.properties.DISTRICT_N && 
                  info.local_munic == feat.properties.MUNICNAME) ||
                  (info.district_munic == feat.properties.DISTRICT_N && 
                  feat.properties.DISTRICT_N == feat.properties.MUNICNAME))  {
                
                cases = cases + parseInt(info.confirmed*1)
                recovered = recovered + parseInt(info.recovered*1)
                deaths = deaths + parseInt(info.deceased*1)
                provincestring = info.province
                level = info.level
                displayRegion = feat.properties.DISTRICT_N + ' ' + feat.properties.MUNICNAME
                city = info.city

                if(info.recovered !== "") {
                  hasRecovered = true
                }

                if(info.deceased !== "") {
                  hasDeaths = true
                }
              }
              
              if (info.district_munic == feat.properties.DISTRICT_N && 
                  (info.local_munic == "" && feat.properties.MUNICNAME == undefined)) {
                      cases = parseInt(info.confirmed*1)
                      recovered = parseInt(info.recovered*1)
                      deaths = parseInt(info.deceased*1)
                      provincestring = info.province
                      level = info.level
                      displayRegion = feat.properties.DISTRICT_N

                      if(info.recovered !== "") {
                        hasRecovered = true
                      }

                      if(info.deceased !== "") {
                        hasDeaths = true
                      }
                  } 
            }

            active = cases - recovered - deaths
            
            feat.properties.confirmed = cases
            feat.properties.recovered = recovered
            feat.properties.deaths = deaths
            feat.properties.active = active
            feat.properties.provincestring = provincestring
            feat.properties.level = level
            feat.properties.displayRegion = displayRegion
            feat.properties.hasRecovered = hasRecovered
            feat.properties.hasDeaths = hasDeaths
            feat.properties.city = city
            feat.id = idCount

            idCount++

            source.data.features.push(feat)
          }

          if (map.getSource("covid-sa-cases-prov-detail")) {
            map.getSource('covid-sa-cases-prov-detail').setData(source.data);
          }

      },
      getSALocalGeoData() {

        var thisRef = this
        var map = thisRef.map
        var source = this.sourcesaprovdetail
      
        
        fetch('../../data/geo/sadistrictlocal_sim.json')
          .then(response => {
            return response.json()
          })
          .then(data => {
            // Work with JSON data here    
            //console.log(data)
            thisRef.dataSAProvinceDetailGeo = data.features    
            //
            thisRef.getProvinceCaseData("data/toupdate/breakdown_regions.csv", callback)    

            function callback(){
              thisRef.processSALocalProvCases()
            }
                  
          })
          .catch(err => {
            // Do something for an error here
            //console.log(err)
        })
      },
      processSAData() {

        var thisRef = this
        var source = thisRef.sourcesa
        var map = this.map
        var data = thisRef.dataSA

        //console.log("MAP DATA", data)

        if (data == null || data == undefined)
          return

        thisRef.sourcesa.data.features = []        

        for (var info of data) {
          let feature = thisRef.getSADataFeaturev2(info)
          if (feature.properties.province !== "Unknown" || feature.properties.province !== "National")
            source.data.features.push(feature)
        }

        if (map.getSource("covid-sa-cases")) {
          map.getSource('covid-sa-cases').setData(thisRef.sourcesa.data);
        }
      },
      getSADataFeaturev2(data) {
          let properties = {};
          let thisRef = this

          for (var key in data) {
              let prop = data[key];      
              
              if (key == "confirmed" || key == "recovered" || key == "deceased")
                prop = parseInt(prop)

              properties[key] = prop;
          }

          var active = (properties["confirmed"]*1) - (properties["recovered"]*1) - (properties["deceased"]*1)
          properties["active"] = active;

          var provinceGeoMap = {}
          provinceGeoMap["Gauteng"] = [28.10, -26.26]
          provinceGeoMap["KwaZulu-Natal"] = [30.87, -28.38]
          provinceGeoMap["Northern Cape"] = [21.74, -29.04]
          provinceGeoMap["Western Cape"] = [21.84, -33.11]
          provinceGeoMap["North West"] = [25.27, -26.61]
          provinceGeoMap["Eastern Cape"] = [26.38, -32.24]
          provinceGeoMap["Limpopo"] = [29.43, -23.22]
          provinceGeoMap["Mpumalanga"] = [30.51, -25.52]
          provinceGeoMap["Free State"] = [26.74, -28.43]
          provinceGeoMap["Unknown"] = []
          provinceGeoMap["National"] = []
          //
          var coords = []
          var province = properties["region"]
          // filter on province
                 
          // string match province to a fixed coord
          var provCoords = []
          for (let prov in provinceGeoMap) {
            
            const found = province.match()
            provCoords = provinceGeoMap[found.input] 
          }

          if (provCoords !== null) {
            coords = provCoords
          }

          let feature = {
              //"id": deviceId,
              "type": "Feature",
              "geometry": {
                  "type": "Point",
                  "coordinates": coords
              },
              "properties": properties
          }
          
          return feature
          
      },
      getSADataFeature(data) {
          let properties = {};
          let thisRef = this

          for (var key in data) {
              let prop = data[key];            
              properties[key] = prop;
          }

          var provinceGeoMap = {}
          provinceGeoMap["Gauteng"] = [28.10, -26.26]
          provinceGeoMap["KwaZulu-Natal"] = [30.87, -28.38]
          provinceGeoMap["Northern Cape"] = [21.74, -29.04]
          provinceGeoMap["Western Cape"] = [21.84, -33.11]
          provinceGeoMap["North West"] = [25.27, -26.61]
          provinceGeoMap["Eastern Cape"] = [26.38, -32.24]
          provinceGeoMap["Limpopo"] = [29.43, -23.22]
          provinceGeoMap["Mpumalanga"] = [30.51, -25.52]
          provinceGeoMap["Free State"] = [26.74, -28.43]
          provinceGeoMap["Unknown"] = []
          //
          var coords = []
          var province = properties["province"]
          // filter on province
                 
          // string match province to a fixed coord
          var provCoords = []
          for (let prov in provinceGeoMap) {
            
            const found = province.match()
            provCoords = provinceGeoMap[found.input] 
          }

          if (provCoords !== null) {
            coords = provCoords
          }

          let feature = {
              //"id": deviceId,
              "type": "Feature",
              "geometry": {
                  "type": "Point",
                  "coordinates": coords
              },
              "properties": properties
          }
          
          return feature
          
      },
      getSAProvinceData() {
        var thisRef = this
        var map = thisRef.map
        fetch('../../data/geo/sa_provinces.json')
          .then(response => {
            return response.json()
          })
          .then(data => {
            // Work with JSON data here
            
            thisRef.sourceSAProvince.data.features = data.features            
            
             if (map.getSource("sa-province"))
               map.getSource('sa-province').setData(thisRef.sourceSAProvince.data);
          })
          .catch(err => {
            // Do something for an error here
            //console.log(err)
        })
      },
      processGlobalData() {
        var thisRef = this
        var data = thisRef.dataGlobal
        var source = thisRef.sourceglobal
        var map = this.map

        for (var info of data) {
          // 
          if (info.attributes.Active == 0) {
              info.attributes.Active = info.attributes.Confirmed - (info.attributes.Deaths + info.attributes.Recovered)
          }
        }

        for (var info of data) {
          // if (info.attributes.Country_Region == "US")
          //   console.log(info.attributes)           
          let feature = thisRef.getFeature(info.attributes)
          source.data.features.push(feature)
        }

        if (map.getSource("covid-global-heat"))
          map.getSource('covid-global-heat').setData(thisRef.sourceglobal.data);
      },
      getFeaturePoly(data) {
        let properties = {};

          for (var key in data) {
              let prop = data[key];            
              properties[key] = prop;
          }

          var coords = null
          if (data.geom !== null) {
            coords = data.geom.coordinates
          }
          
          let feature = {
              //"id": deviceId,
              "type": "Feature",
              "geometry": {
                  "type": "Polygon",
                  "coordinates": coords
              },
              "properties": properties
          }
          
          return feature

      },
      getFeature(data) {
          let properties = {};

          for (var key in data) {
              let prop = data[key];            
              properties[key] = prop;
          }

          // var coords = null
          // if (data.Long_ !== null && data.Lat  !== null) {
          //   coords = [data.Long_, data.Lat]
          // }
          
          var coords = [data.Long_, data.Lat]

          let feature = {
              //"id": deviceId,
              "type": "Feature",
              "geometry": {
                  "type": "Point",
                  "coordinates": coords
              },
              "properties": properties
          }
          
          return feature
      },
      processClusterClick(data) {

        // transmission type
        var travelpercent = 0
        var localpercent = 0
        var unknownpercent = 0

        // gender 
        var malepercent = 0
        var femailpercent = 0

        var cases = []
        for (var key in data) {
          let feature = data[key]
          cases.push(feature.properties)
        }

        var gender = this.calculateGender(cases)
        //console.log(gender)

        var transmissionTypes = this.calculateTransmissionTypes(cases)
        //console.log(transmissionTypes)

        var transTypes = {}
        for (let key in transmissionTypes) {
          let feature = transmissionTypes[key]

          if (feature.perc > 0 && feature.perc !== undefined)
            transTypes[feature.type] = feature.perc         
        }

        var age = this.calculateAge(cases)
        var ageRanges = {}
        for (let key in age) {
          let feature = age[key]
          if (feature.perc > 0)
            ageRanges[feature.age] = feature.perc          
        }

        return {
          gender: gender,
          transmissionTypes: transTypes,
          age: ageRanges
        }

      },
      calculateGender(data) {

        //first get the total active
        //var match = data.filter(c => c.status === "Active")
        var total = data.length

        //get males
        var match = data.filter(c => c.gender === "Male")
        var maleCount = match.length

        //get females
        var match = data.filter(c => c.gender === "Female")
        var femaleCount = match.length

        //get unknown
        var match = data.filter(c => c.gender === "Unknown")
        var unknownCount = match.length

        //calc perc
        var perc = (maleCount/total) * 100
        var malePerc = parseFloat(perc.toFixed(0))

        var perc = (femaleCount/total) * 100
        var femalePerc = parseFloat(perc.toFixed(0))

        var perc = (unknownCount/total) * 100
        var unknownPerc = parseFloat(perc.toFixed(0))

        return {malePercent: malePerc, femalePercent: femalePerc, unknownPerc: unknownPerc}

      }, 
      calculateTransmissionTypes(data) {
        var tt = []

        //loop to sort per type
        for (var i = 0; i < data.length; i++) {
          var cas = data[i]
          
          //if(cas.status === "Active") {
            var match = tt.find(d => d.type === cas.transmission_type)
            if(match) {
              //found so increment
              match.count += 1
            }
            else {
              //not found
              tt.push({type: cas.transmission_type, count: 1, perc: 0, color: ""})
            }
          //}          
        }

        //get the total active
        var total = data.length //data.filter(c => c.status === "Active").length

        //loop and calc the perc and assign a color
        var cols = ['#3F51B5','#008FFB','#2B908F','#449DD1']
        for (var i = 0; i < tt.length; i++) {
          
          //calc perc
          var perc = (tt[i].count/total) * 100        

          tt[i].perc = parseFloat(perc.toFixed(0))

          //color
          tt[i].color = cols[i]
        }

        //set the data
        return tt
      },
      calculateAge(data) {
        //init data
        var ag = [
          {age: "<18", count: 0, perc: 0, color: "#fcc5c0"},
          {age: "18-24", count: 0, perc: 0, color: "#fa9fb5"},
          {age: "25-34", count: 0, perc: 0, color: "#f768a1"},
          {age: "35-44", count: 0, perc: 0, color: "#dd3497"},
          {age: "45-54", count: 0, perc: 0, color: "#ae017e"},
          {age: "55-64", count: 0, perc: 0, color: "#7a0177"},
          {age: "65+", count: 0, perc: 0, color: "#7105a2"}
        ]

        //loop and set counts
        for (var i = 0; i < data.length; i++) {
          var cas = data[i]
          var age = cas.age *1

          //if(cas.status === "Active") {
            if(age < 18) {
              ag[0].count += 1
            }
            else if(age >= 18 && age <=24) {
              ag[1].count += 1
            }
            else if(age >= 25 && age <=34) {
              ag[2].count += 1
            }
            else if(age >= 35 && age <=44) {
              ag[3].count += 1
            }
            else if(age >= 45 && age <=54) {
              ag[4].count += 1
            }
            else if(age >= 55 && age <=64) {
              ag[5].count += 1
            }
            else if(age >= 65) {
              ag[6].count += 1
            }
          //}
        }

        //get the total active
        var total = data.length //data.filter(c => c.status === "Active").length

        //loop and calc the perc
        var cols = ['#3F51B5','#008FFB','#2B908F','#449DD1']
        for (var i = 0; i < ag.length; i++) {
          
          //calc perc
          var perc = (ag[i].count/total) * 100
          ag[i].perc = parseFloat(perc.toFixed(0))
        }

        //set the data
        return ag
      },
      getSelectedHeatValue(e) {
        //console.log(e.srcElement.value)
        this.globalHeatSelector = e.srcElement.value

        var map = this.map

        map.setPaintProperty('Global Heatmap', 'heatmap-weight', [
            'interpolate',
            ['linear'],
            ['get', this.globalHeatSelector],
            0,                    
            0,
            6,
            1                   
        ])
      },
      toggleLayerPicker() {
        this.showLayerPicker = !this.showLayerPicker
      }
    }
  }
</script>

<style scoped>
  .mapbox-map {
    width: 100%;
    height: 100%;
    background: #45516e;
    border-radius: 4px;
  }

  
</style>

<style>

  .map-toggle-global-heat {
    background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGhlaWdodD0iOC4wNjNtbSIgc3R5bGU9InNoYXBlLXJlbmRlcmluZzpnZW9tZXRyaWNQcmVjaXNpb247IHRleHQtcmVuZGVyaW5nOmdlb21ldHJpY1ByZWNpc2lvbjsgaW1hZ2UtcmVuZGVyaW5nOm9wdGltaXplUXVhbGl0eTsgZmlsbC1ydWxlOmV2ZW5vZGQ7IGNsaXAtcnVsZTpldmVub2RkIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCA2MDAgNTk5IiB3aWR0aD0iOC4wNjYxbW0iIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+CiAgIDwhW0NEQVRBWwogICAgLmZpbDAge2ZpbGw6YmxhY2t9CiAgIF1dPgogIDwvc3R5bGU+PC9kZWZzPjxnIGlkPSJMYXllcl94MDAyMF8xIj48cGF0aCBjbGFzcz0iZmlsMCIgZD0iTTIzNyA1OTNjLTE2MiwtMzUgLTI2NSwtMTk0IC0yMzAsLTM1NiAxLC03IDMsLTE1IDUsLTIybDUxIDQ2IDAgMCAxMDEgOTIgLTkxIDI3YzcsMTggMTUsMzUgMjUsNTAgMzMsNTIgODcsOTEgMTUxLDEwNSAxNSwzIDI5LDQgNDMsNWwtMiA1OWMtMTgsMCAtMzUsLTIgLTUzLC02em0zNTAgLTIxMGwwIC0xIDEgMWMyLC03IDMsLTEzIDUsLTIwIDM1LC0xNjIgLTY4LC0zMjIgLTIzMCwtMzU2IC0yMCwtNSAtNDAsLTcgLTYwLC03bC0xIDU5YzE2LDEgMzIsMiA0OCw2IDY1LDE0IDExOCw1MyAxNTIsMTA0IDEwLDE3IDE5LDM0IDI1LDUybC05MiAyNSAxNTIgMTM3em0tMjk1IC0xMGMtMTIsLTQgLTIwLC0xNSAtMjAsLTI3IDAsLTE2IDEyLC0yOCAyOCwtMjggMTUsMCAyNywxMiAyNywyOCAwLDEyIC04LDIzIC0yMCwyN2wwIDE4IC0xNSAwIDAgLTE4em0tMzAgLTEwMWwzOCAwIDM4IDAgMCAtMjZjMCwtMTAgLTUsLTIwIC0xMSwtMjdsMCAwYy03LC03IC0xNywtMTEgLTI3LC0xMSAtMTEsMCAtMjAsNCAtMjcsMTFsMCAwYy03LDcgLTExLDE3IC0xMSwyN2wwIDI2em0xNDEgNzBjMCw1NyAtNDYsMTA0IC0xMDMsMTA0IC01NywwIC0xMDQsLTQ3IC0xMDQsLTEwNGwwIC03MCAyMSAwIDAgLTM2YzAsLTIyIDEwLC00MyAyNSwtNThsLTEgMGMxNSwtMTUgMzYsLTI0IDU5LC0yNCAyMywwIDQzLDkgNTgsMjRsMCAwYzE1LDE1IDI0LDM2IDI0LDU4bDAgMzYgMjIgMCAwIDcwIC0xIDB6Ii8+PC9nPjwvc3ZnPg==);
    background-repeat: no-repeat;
    background-size: 20px;
    background-position: center;    
  }

  .mapboxgl-popup {
    margin-top: -15px;
  }

  .popup-class {
    color: black;
    opacity: 0.85;
  }

  #heatSelect {
    background: #7c219a;
    position: absolute;
    z-index: 9999;
    top: 60px;
    left: 0;
    width: 140px;
    font-family: 'Open Sans', sans-serif;
    -moz-text-align-last: center;
    text-align-last: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.25);
    height: 40px;
  }

  .heatSelectOption {
    text-indent: 40%;    
    text-align-last: center;
  }

  #menulayer {
    background-color: #ffffff;
    position: absolute;
    z-index: 9999;
    top: 185px;
    right: 10px;
    border-radius: 3px;
    width: 30px;
    height: 30px;
    font-family: 'Open Sans', sans-serif;
    text-align: center;
  }
  
  #menu {
    background-color: #181745;
    position: absolute;
    z-index: 9999;
    top: 0;
    left: 0;
    border-radius: 3px;
    width: 140px;
    font-family: 'Open Sans', sans-serif;
    text-align: center;    
  }
    
  #menu a {
    font-size: 13px;
    color: #8b8b8b;
    display: block;
    margin: 0;
    padding: 0;
    padding: 10px;
    text-decoration: none;
    text-align: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.25);
  }
    
  #menu a:last-child {
    border: none;
  }
    
  #menu a:hover {
    background-color: #f7efef6e;
    color: #404040;
  }
    
  #menu a.active {
    background-color: #8d24aad0;
    color: #ffffff;
  }
    
  #menu a.active:hover {
    background: #8e24aa59;
  }

  .legend {
    bottom: 0;
    font: 12px/20px 'Helvetica Neue', Arial, Helvetica, sans-serif;
    padding: 10px;
    position: absolute;
    left: 0;
    z-index: 1;
    color: #fffbfb;
    }
    
  .legend h4 {
    margin: 0 0 10px;
  }
    
  .legend div span {
    border-radius: 50%;
    display: inline-block;
    height: 10px;
    margin-right: 5px;
    width: 10px;
  }

</style>